import browsingHistoryIcon from '@/shared/assets/icons/browsing-history.svg';
import lifebuoyIcon from '@/shared/assets/icons/lifebuoy.svg';
import ribbonIcon from '@/shared/assets/icons/ion-ribbon-b.svg';

export interface PdpTrustBadge {
  id: string;
  icon: string;
  title?: string;
  titleLines?: readonly string[];
  href: string;
}

export const PDP_TRUST_BADGES: readonly PdpTrustBadge[] = [
  {
    id: 'refund',
    icon: browsingHistoryIcon,
    title: '30 Day Returnable',
    href: '/shipping-return.html#30-day-return',
  },
  {
    id: 'exchange',
    icon: lifebuoyIcon,
    titleLines: ['Lifetime Exchange', '& Buy-Back'],
    href: '/shipping-return.html#lifetime-exchange',
  },
  {
    id: 'certified',
    icon: ribbonIcon,
    title: 'Certified Jewellery',
    href: '/certifications.html',
  },
];
